import { render, staticRenderFns } from "./screen3.vue?vue&type=template&id=3c0823ef&"
import script from "./screen3.vue?vue&type=script&lang=js&"
export * from "./screen3.vue?vue&type=script&lang=js&"
import style0 from "./screen3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports